import TyHoursLabel from './TyHoursLabel.vue'
export default TyHoursLabel



// WEBPACK FOOTER //
// ./src/components/ty-hours-label/index.js